import { useState } from "react";
import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { OrderDialog } from "./OrderDialog";
import { Reveal, Label } from "./Reveal";
import { TIERS, mailto } from "./content";

const Tier = ({ t, i }) => {
  const [open, setOpen] = useState(false);
  return (
  <Reveal delay={i * 0.1} className="h-full">
    <motion.div whileHover={{ y: -8 }} transition={{ type: "spring", stiffness: 260, damping: 20 }} data-testid={`pricing-card-${t.id}`}
      className={`relative flex h-full flex-col rounded-3xl border p-8 sm:p-10 ${t.featured ? "border-[var(--teal)] bg-[var(--navy-2)] shadow-[0_0_80px_-20px_rgba(45,226,208,0.4)]" : "border-white/10 bg-[var(--ink)]"}`}>
      {t.featured && <span className="font-mono-d absolute -top-3 left-8 rounded-full bg-[var(--teal)] px-3 py-1 text-[11px] uppercase tracking-widest text-[var(--ink)]">Most chosen</span>}
      <p className="text-lg font-semibold text-white">{t.name}</p>
      <p className="mt-1 text-sm text-slate-400">{t.blurb}</p>
      <p className="font-serif-d mt-8 text-7xl text-white" data-testid={`pricing-price-${t.id}`}>${t.price}</p>
      <ul className="mt-8 flex-1 space-y-3.5">
        {t.items.map((it) => (
          <li key={it} className="flex gap-3 text-[15px] text-slate-300">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-[var(--teal)]" />{it}
          </li>
        ))}
      </ul>
      <button onClick={() => setOpen(true)} data-testid={`pricing-cta-${t.id}`}
        className={`group mt-10 flex items-center justify-center gap-2 rounded-full px-6 py-4 font-semibold transition-transform duration-300 hover:scale-[1.03] active:scale-95 ${t.featured ? "bg-[var(--teal)] text-[var(--ink)]" : "border border-white/15 text-white hover:border-[var(--teal)]"}`}>
        Order for ${t.price} <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
      </button>
      <OrderDialog tier={t} open={open} onOpenChange={setOpen} />
      <a href={mailto(`Question about ${t.name}`)} data-testid={`pricing-question-${t.id}`}
        className="mt-4 text-center text-sm text-slate-400 underline-offset-4 transition-colors hover:text-[var(--teal)] hover:underline">
        Questions first? Email us
      </a>
    </motion.div>
  </Reveal>
  );
};

export const Pricing = () => (
  <section id="pricing" className="relative border-t border-white/5 bg-[var(--navy)] py-28 sm:py-36" data-testid="pricing-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Label>Pricing</Label>
          <h2 className="font-serif-d mt-5 text-5xl leading-[0.95] text-white sm:text-6xl">Pick your <span className="italic text-[var(--teal)]">scope.</span></h2>
        </div>
        <p className="max-w-sm text-base text-slate-300">Attach your resume and target job, then pay by card or bank transfer. Need it fast? Add 24-hour rush delivery for $25.</p>
      </Reveal>
      <div className="mt-16 grid items-stretch gap-6 md:grid-cols-3">
        {TIERS.map((t, i) => <Tier key={t.id} t={t} i={i} />)}
      </div>
    </div>
  </section>
);
